import {CoreDI, Installer} from '@gongxigames/framework/core';
import {GameConfig} from '@gongxigames/framework/slot/types';

export function isEnabledRubyCoins(components: Installer): boolean {
    return components.getComponent<GameConfig>(CoreDI.GameConfig).isRubyCoinsGame || false;
};
